import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import ArticleOutlined from "@mui/icons-material/ArticleOutlined";
import BeachAccessRounded from "@mui/icons-material/BeachAccessRounded";
import AssignmentOutlined from "@mui/icons-material/AssignmentOutlined";
import DemandeTable from "./components/DemandeTable";
import CongeTable from "./components/CongeTable";

const TABS = [
    { value: "attestations", label: "Attestations", Icon: ArticleOutlined },
    { value: "conges", label: "Congés", Icon: BeachAccessRounded },
];

export default function Demande() {
    const [tab, setTab] = useState("attestations");

    return (
        <Box sx={{ p: { xs: 2, md: 3 } }}>
            <Box sx={{ p: { xs: 2, md: 2.5 }, borderRadius: '14px', background: '#fff', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(15,23,42,0.05)' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                        <Box sx={{ width: 38, height: 38, borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#ebf4fb', color: '#03407b' }}>
                            <AssignmentOutlined />
                        </Box>
                        <Box>
                            <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.2 }}>Gestion des demandes</Typography>
                            <Typography sx={{ fontSize: '0.78rem', color: '#64748b' }}>Traitez les demandes d'attestation et de congé des collaborateurs</Typography>
                        </Box>
                    </Box>

                    <Box role="tablist" sx={{ ml: { md: 'auto' }, display: 'flex', p: 0.5, gap: 0.5, borderRadius: '12px', background: '#f1f5f9' }}>
                        {TABS.map(({ value, label, Icon }) => {
                            const active = tab === value;
                            return (
                                <Box
                                    key={value}
                                    role="tab"
                                    aria-selected={active}
                                    tabIndex={0}
                                    onClick={() => setTab(value)}
                                    onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setTab(value)}
                                    sx={{
                                        display: 'flex', alignItems: 'center', gap: 0.75, px: 1.75, py: 0.75, borderRadius: '9px', cursor: 'pointer',
                                        fontSize: '0.88rem', fontWeight: 700, userSelect: 'none', transition: 'all 0.15s ease',
                                        color: active ? '#03407b' : '#64748b',
                                        background: active ? '#fff' : 'transparent',
                                        boxShadow: active ? '0 1px 3px rgba(15,23,42,0.12)' : 'none',
                                        '&:hover': { color: '#03407b' },
                                        '&:focus-visible': { outline: '2px solid #aed6f1' },
                                    }}
                                >
                                    <Icon sx={{ fontSize: 18 }} /> {label}
                                </Box>
                            );
                        })}
                    </Box>
                </Box>

                {tab === "attestations" ? <DemandeTable typeFilter="Attestation" /> : <CongeTable />}
            </Box>
        </Box>
    );
}
